export const SET_FOODORA_RESTAURANTS = 'SET_FOODORA_RESTAURANTS'
export const SET_FOODORA_RESTAURANTS_TOTAL_LENGTH = 'SET_FOODORA_RESTAURANTS_TOTAL_LENGTH'
export const SET_FOODORA_RESTAURANT = 'SET_FOODORA_RESTAURANT'
export const APPEND_FOODORA_RESTAURANTS = 'APPEND_FOODORA_RESTAURANTS'
export const SET_FOODORA_RESTAURANTS_SHOW_MODAL = 'SET_FOODORA_RESTAURANTS_SHOW_MODAL'
export const SET_FOODORA_COPY_DATA = 'SET_FOODORA_COPY_DATA'
